import React, { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  useMediaQuery,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import NavbarLogin from "scenes/widgets/navbarlogin";
import Footer from "scenes/widgets/footer";
// import PopupWidget from "scenes/widgets/PopupWidget.jsx";
import PopupWidgetHome from "scenes/widgets/PopupWidgetHome.jsx";
import MyPostWidget from "scenes/widgets/MyPostWidget.jsx";
import PostsWidget from "scenes/widgets/PostsWidget.jsx";

const WettbewerbPage = () => {
  const isNonMobileScreens = useMediaQuery("(min-width:1000px)");
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [sortMode, setSortMode] = useState("date");
  const [refreshKey, setRefreshKey] = useState(0);
  const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);

  return (
    <Box>
      <NavbarLogin />
      {/* <PopupWidget /> */}
      <PopupWidgetHome />

      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          px: isNonMobileScreens ? 0 : 2,
        }}
      >
        <Box sx={{ textAlign: "center", mb: 4 }}>
          <Typography variant="h2" component="h1">
            UNSER WETTBEWERB
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: isNonMobileScreens ? "row" : "column",
            alignItems: "center",
            gap: "40px",
            marginTop: "40px",
            marginBottom: "50px",
          }}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <Box
              component="img"
              src="/assets/wettbewerb/wettbewerb_hero_cropped.jpg"
              alt="Wettbewerb Hero"
              sx={{
                width: "100%",
                height: "auto",
                borderRadius: isNonMobileScreens ? "12px" : "0px",
              }}
            />
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="h6"
              sx={{
                lineHeight: 1.6,
                marginBottom: '30px',
                paddingLeft: isNonMobileScreens ? '0px' : '20px',
                paddingRight: isNonMobileScreens ? '0px' : '20px'
              }}
            >
              Deine Idee. Dein erstes Geld. Deine Zukunft.
              <br></br><br></br>
              Gestalte dein eigenes Kunstwerk, verdiene dabei Geld und werde Teil eines echten Netzwerks aus Künstlern, Unternehmen und Events.
              <br></br><br></br>
              Mach mit – und starte schon heute in deine Zukunft.
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: isNonMobileScreens ? "flex-start" : "center",
                px: isNonMobileScreens ? 0 : 2.5,
              }}
            >
              <Button variant="contained" onClick={() => setIsInfoPopupOpen(true)}>
                Mehr erfahren
              </Button>
            </Box>
          </Box>
        </Box>

        <MyPostWidget onPostCreated={() => setRefreshKey((prev) => prev + 1)} />

        {/* {!user && (
          <Typography textAlign="center" mt="1rem" mb="1.5rem">
            Melde dich an, um eigene Beitrage zu posten und Likes zu vergeben.
          </Typography>
        )} */}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mt="2rem"
          mb="1rem"
          flexWrap="wrap"
          gap="1rem"
        >
          <Typography variant="h4">Galerie</Typography>
          <ToggleButtonGroup
            value={sortMode}
            exclusive
            onChange={(_, value) => {
              if (value) setSortMode(value);
            }}
            size="small"
          >
            <ToggleButton value="date">Neueste</ToggleButton>
            <ToggleButton value="likes">Top Likes</ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <PostsWidget sort={sortMode} refreshKey={refreshKey} />
      </Box>

      <Dialog
        open={isInfoPopupOpen}
        onClose={() => setIsInfoPopupOpen(false)}
        fullScreen={isSmallScreen}
        fullWidth
        maxWidth="md"
        scroll="paper"
        PaperProps={{
          sx: {
            m: isSmallScreen ? 1 : 4,
            width: isSmallScreen ? "calc(100% - 16px)" : undefined,
            maxHeight: isSmallScreen ? "calc(100% - 16px)" : "calc(100% - 64px)",
          },
        }}
      >
        <DialogTitle sx={{ pr: 4 }}>Der Kunstkaleidoskop-Wettbewerb</DialogTitle>
        <DialogContent
          dividers
          sx={{
            overflowX: "hidden",
            "& *": {
              overflowWrap: "anywhere",
              wordBreak: "break-word",
            },
            "& ul, & ol": {
              paddingLeft: isSmallScreen ? 2.5 : 3,
            },
          }}
        >
          <Typography paragraph>
            Beim Kunstkaleidoskop geht es nicht nur um Kreativität.
          </Typography>
          <Typography paragraph>
            Es geht darum, erste Schritte ins echte Leben zu machen, Geld zu verdienen,
            Kontakte zu knüpfen und Chancen zu nutzen.
          </Typography>
          <Typography paragraph>
            Du gestaltest ein Kunstwerk – und öffnest dir gleichzeitig Türen in deine Zukunft.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            So funktioniert es
          </Typography>
          <Box component="ol" sx={{ pl: 3, mb: 2 }}>
            <li>
              <Typography fontWeight={700}>Hol dir dein Kunstkaleidoskop</Typography>
              <Box component="ul" sx={{ mt: 0.5, mb: 1.5 }}>
                <li><Typography>kostenlos bei unseren Partnern</Typography></li>
                <li><Typography>oder für 9,90 € direkt bei uns</Typography></li>
              </Box>
            </li>
            <li>
              <Typography fontWeight={700}>Gestalte dein eigenes Kunstwerk</Typography>
              <Box component="ul" sx={{ mt: 0.5, mb: 1.5 }}>
                <li><Typography>kreativ, individuell, einzigartig</Typography></li>
              </Box>
            </li>
            <li>
              <Typography fontWeight={700}>Reiche es bei uns ein</Typography>
              <Box component="ul" sx={{ mt: 0.5, mb: 1.5 }}>
                <li><Typography>aktuell bei Events oder donnerstags</Typography></li>
                <li><Typography>später regelmäßig bei unseren Netzwerktreffen</Typography></li>
              </Box>
            </li>
            <li>
              <Typography fontWeight={700}>Erhalte deine Auszahlung</Typography>
              <Box component="ul" sx={{ mt: 0.5, mb: 1.5 }}>
                <li><Typography>unter 100 Likes → 9,90 €</Typography></li>
                <li><Typography>ab 100 Likes → 20 €</Typography></li>
                <li><Typography>ab 500 Likes → 30 €</Typography></li>
                <li><Typography>ab 1000 Likes → 100 €</Typography></li>
              </Box>
            </li>
          </Box>
          <Typography paragraph>
            Du bekommst dein Geld garantiert zurück – oder deutlich mehr.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            Was danach passiert
          </Typography>
          <Typography paragraph>
            Mit der Abgabe geht dein Kunstwerk in unseren Besitz über.
          </Typography>
          <Typography component="div" paragraph>
            Es wird:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>ausgestellt</Typography></li>
              <li><Typography>veröffentlicht</Typography></li>
              <li><Typography>verkauft oder versteigert</Typography></li>
            </Box>
          </Typography>
          <Typography paragraph>
            Ab 1000 Likes wird dein Werk zusätzlich auf Instagram präsentiert und Teil unserer Eventreihe.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            🚀 Dein größter Vorteil: Netzwerk & Zukunft
          </Typography>
          <Typography component="div" paragraph>
            Mit deiner Teilnahme wirst du Teil eines echten Netzwerks aus:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>Künstlern</Typography></li>
              <li><Typography>Unternehmern</Typography></li>
              <li><Typography>Arbeitgebern</Typography></li>
              <li><Typography>kreativen Projekten</Typography></li>
              <li><Typography>Jugendlichen mit ähnlichen Zielen</Typography></li>
            </Box>
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            💼 Deine Chancen bei uns
          </Typography>
          <Typography component="div" paragraph>
            Wenn du aktiv bist und Engagement zeigst, hast du echte Möglichkeiten:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>Vermittlung von Praktika</Typography></li>
              <li><Typography>Zugang zu Ausbildungsplätzen</Typography></li>
              <li><Typography>Kontakte zu über 7000 Unternehmen im Großraum Hamburg</Typography></li>
              <li><Typography>Einblicke in echte Berufe und Branchen</Typography></li>
            </Box>
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            🎓 Förderung & Einstiegsmöglichkeiten
          </Typography>
          <Typography component="div" paragraph>
            Wir gehen noch weiter:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>besonders engagierte Teilnehmer können Werkstipendien erhalten</Typography></li>
              <li><Typography>Einstiegsmöglichkeiten in unsere Projekte</Typography></li>
              <li><Typography>Studenten starten bei uns bereits ab 20 € pro Stunde</Typography></li>
              <li><Typography>direkte Vermittlung an Unternehmen möglich</Typography></li>
            </Box>
          </Typography>
          <Typography paragraph>
            Du kannst bei uns nicht nur mitmachen – du kannst bei uns starten.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            🤝 Netzwerken vor Ort
          </Typography>
          <Typography component="div" paragraph>
            Alle Teilnehmer, die ein Kunstwerk eingereicht haben, sind eingeladen:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>gemeinsam mit Künstlern</Typography></li>
              <li><Typography>mit Unternehmern</Typography></li>
              <li><Typography>mit anderen motivierten Jugendlichen</Typography></li>
            </Box>
          </Typography>
          <Typography paragraph>
            zu netzwerken, Erfahrungen zu sammeln und Kontakte aufzubauen.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            📅 Unsere Events & Treffen
          </Typography>
          <Typography paragraph>Bis zu den Sommerferien:</Typography>
          <Typography paragraph>
            Jeden ersten Samstag im Monat
            <br />
            🕛 12:00 – 18:00 Uhr
            <br />
            📍 im Kunstkaleidoskop
          </Typography>
          <Typography paragraph>Ab neuem Schuljahr (nach den Sommerferien):</Typography>
          <Typography paragraph>
            Jeden Donnerstag
            <br />
            🕓 ab 16:00 Uhr – Open End
            <br />
            Afterwork, Networking, Ausstellung
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            🎯 Unser Ziel
          </Typography>
          <Typography component="div" paragraph>
            Wir wollen, dass jedes Schulkind:
            <Box component="ul" sx={{ mt: 1, mb: 0 }}>
              <li><Typography>kreativ wird</Typography></li>
              <li><Typography>Geld verdient</Typography></li>
              <li><Typography>echte Kontakte knüpft</Typography></li>
              <li><Typography>eine Perspektive bekommt</Typography></li>
            </Box>
          </Typography>
          <Typography paragraph>
            Kunstkaleidoskop ist dein Einstieg in die Zukunft.
          </Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            📅 Eventbeschreibung (für Eventseite)
          </Typography>
          <Typography paragraph sx={{ mb: 1 }}>
            Kunstkaleidoskop Netzwerk- & Erlebnis-Event
          </Typography>
          <Typography paragraph sx={{ mb: 0.5 }}>
            Datum: Samstag, 04. April
          </Typography>
          <Typography paragraph sx={{ mb: 0.5 }}>
            Uhrzeit: 12:00 – 18:00 Uhr
          </Typography>
          <Typography paragraph>Ort: Kunstkaleidoskop</Typography>

          <Divider sx={{ my: 2 }} />

          <Typography variant="h5" gutterBottom>
            Eintritt
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 2 }}>
            <li><Typography>kostenfrei für alle teilnehmenden Künstler</Typography></li>
            <li><Typography>kostenfrei für alle Werbepartner</Typography></li>
            <li><Typography>10 € Eintritt für externe Besucher</Typography></li>
          </Box>

          <Typography variant="h5" gutterBottom>
            Was dich erwartet
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 2 }}>
            <li><Typography>🎨 Ausstellung von Kunstkaleidoskopen</Typography></li>
            <li><Typography>🔨 Live-Versteigerungen (Startgebot ab 9,90 €)</Typography></li>
            <li><Typography>📸 Themen-Events (aktuell: Fotoapparate, Auktionen ab 1 €)</Typography></li>
            <li><Typography>🤝 Networking mit Künstlern & Unternehmern</Typography></li>
            <li><Typography>🎓 Einblicke in Praktika, Jobs & Chancen</Typography></li>
            <li><Typography>🎁 Gewinne & Überraschungen von unseren Partnern</Typography></li>
            <li><Typography>🍿 Snacks & Softdrinks vor Ort</Typography></li>
          </Box>

          <Typography variant="h5" gutterBottom>
            Besonderheiten
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 2 }}>
            <li><Typography>Künstler helfen vor Ort beim kreativen Arbeiten</Typography></li>
            <li><Typography>Unternehmer sind persönlich anwesend</Typography></li>
            <li><Typography>direkte Gespräche und Kontakte möglich</Typography></li>
            <li><Typography>Teilnahme an einer wachsenden Community</Typography></li>
          </Box>

          <Typography variant="h5" gutterBottom>
            Ziel des Events
          </Typography>
          <Box component="ul" sx={{ mt: 1, mb: 2 }}>
            <li><Typography>Kunst erleben</Typography></li>
            <li><Typography>Menschen kennenlernen</Typography></li>
            <li><Typography>Chancen entdecken</Typography></li>
            <li><Typography>Teil eines Netzwerks werden</Typography></li>
          </Box>

          <Typography>
            Sei dabei und erlebe, wie aus Kreativität echte Möglichkeiten entstehen.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: isSmallScreen ? 2 : 3, pb: isSmallScreen ? 2 : 1.5 }}>
          <Button onClick={() => setIsInfoPopupOpen(false)}>Schließen</Button>
        </DialogActions>
      </Dialog>

      <Footer />
    </Box>
  );
};

export default WettbewerbPage;
